<div class="nav-mobile" role="navigation" aria-label="primary">
  <div class="controls">
    <button type="button" class="close toggle-nav">
      <span class="sr-only">Close</span>
    </button>
  </div>
  <ul class="list-group panel-group" id="nav-mobile-collapse">
    <li class="mobile-account" *ngIf="appSettings.showAccount">
      <span class="fa fa-user margin-right-5"></span> Hi
      <span [hidden]="!userName">, </span>
      <span id="mobile-username" class="text-capitalize">{{userName}}</span>
      <div class="account-links">
        <ul *ngIf="accountLinks.length > 0">
          <li *ngFor="let item of accountLinks">
            <a href="{{item.url}}">{{item.title}}</a>
          </li>
        </ul>
      </div>
    </li>
    <li *ngIf="appSettings.showAlerts">
      <a href="{{alertsUrl}}" tabindex="0">
        <span class="fa fa-bell margin-right-5"></span>Alerts
        <gn-alert-count [domain]="domain"></gn-alert-count>
      </a>
    </li>
    <li *ngIf="appSettings.showSignup">
      <a href="{{registerUrl}}" tabindex="0">
        <span class="fa fa-user-plus margin-right-5"></span>Create profile
      </a>
    </li>
    <li *ngIf="!appSettings.showAccount">
      <a href="{{homeUrl}}" class="mobile-home-link">Home</a>
    </li>
    <li [ngClass]="{active: primaryNavItem.isActive === 'true'}" *ngFor="let primaryNavItem of primaryNavs">
      <a class="accordion-icon-control" data-toggle="collapse" [href]="'#' + primaryNavItem.name" *ngIf="primaryNavItem.isActive === 'true' && primaryNavItem.children">
        <span class="accordion-icon margin-right-5"></span> {{primaryNavItem.title}}</a>

      <a [ngClass]="{active: primaryNavItem.isActive === 'true'}" [href]="primaryNavItem.url" id="{{primaryNavItem.name}}" *ngIf="primaryNavItem.isActive === 'false' || !primaryNavItem.children">
        <span *ngIf="primaryNavItem.children.length > 0" class="fa fa-chevron-right accordion-icon margin-right-5"></span>{{primaryNavItem.title}}</a>
      <div id="{{primaryNavItem.name}}" class="collapse in" aria-expanded="false" *ngIf="primaryNavItem.isActive === 'true' && primaryNavItem.children">
        <ul>
          <li [ngClass]="{'hide': secondaryNavItem.isHidden}" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" *ngFor="let secondaryNavItem of primaryNavItem.children">
            <a [ngClass]="{active: secondaryNavItem.isActive === 'true'}" *ngIf="secondaryNavItem.isRouter === 'true' && !secondaryNavItem.isHidden" [routerLink]="secondaryNavItem.url"
              id="{{secondaryNavItem.id}}">{{secondaryNavItem.title}}</a>
            <a [ngClass]="{active: secondaryNavItem.isActive === 'true'}" *ngIf="secondaryNavItem.isRouter === 'false' && !secondaryNavItem.isHidden" [href]="secondaryNavItem.url"
              id="{{secondaryNavItem.id}}">{{secondaryNavItem.title}}</a>
          </li>
        </ul>
      </div>
    </li>
  </ul>
  <ul class="list-group global-links" id="mobile-global-links" data-qa="mobile-global-links" >
     <li *ngIf="feedbackSSOId">
          <a href="javascript:void(0);" (click)="OpenSurveyWindow()" >Feedback</a>
      </li>
      <li *ngFor="let globalLinkItem of globalLinks" ><a href="{{globalLinkItem.url}}" class="list-group-item">{{globalLinkItem.title}}</a></li>
  </ul>
</div>
